import React, { FC } from 'react';
import { useFormContext, useController } from 'react-hook-form';
import { JobTitleWithDescDto } from '@domain/rs/code/JobTitleRs';
import { JobGroupWithTitlesDescDto } from '@domain/rs/code/JobGroupsWithTitlesRs';

import classnames from 'classnames/bind';
import styles from '../jobSelectModal.module.scss';
const cx = classnames.bind(styles);

interface IJobTitleCardProps {
  vo: JobTitleWithDescDto;
  on: boolean;
  onSelect: () => void;
}

const JobTitleCard: FC<IJobTitleCardProps> = ({ vo, on, onSelect }) => {
  const { name, description } = vo;
  return (
    <li className={cx('listItem')}>
      <a className={cx('btnJob', { on })} role="button" onClick={onSelect}>
        <em className={cx('jobTitle')}>{name}</em>
        <p className={cx('jobDesc')}>{description}</p>
      </a>
    </li>
  );
};

interface IJobTitleCardListProps {
  fieldName: string;
  isHidden: boolean;
  list: JobTitleWithDescDto[];
}

const JobTitleCardList: FC<IJobTitleCardListProps> = ({ fieldName, list, isHidden }) => {
  const { control } = useFormContext();
  const { field } = useController({
    control,
    name: fieldName,
  });

  const jobTitleCardListEl = list.map((item) => {
    const isOn = field.value?.includes(item.code);

    const toggleJobGroupList = () => {
      if (isOn) {
        field.onChange(field.value.filter((filteredItem: number) => filteredItem !== item.code));
      } else {
        const tempList = field.value ?? [];
        field.onChange([...tempList, item.code]);
      }
    };

    return <JobTitleCard key={item.code} vo={item} on={isOn} onSelect={toggleJobGroupList} />;
  });

  return <ul className={cx('jobList', { hidden: isHidden })}>{jobTitleCardListEl}</ul>;
};

interface IJobTitleContentsProps {
  jobGroupFieldName: string; //첫번째 직군 화면 선택 항목 참조용 FieldName

  namePrefix: string;
  jobTitleFieldName: string;
  activeTab: number;
}

const JobTitleContents: FC<IJobTitleContentsProps> = ({
  namePrefix,
  jobGroupFieldName,
  jobTitleFieldName,
  activeTab,
}) => {
  const { watch } = useFormContext();
  const watchJobGroups = watch(jobGroupFieldName) as JobGroupWithTitlesDescDto[];

  const jobTitleContentsEl = watchJobGroups?.map(({ code, jobTitleDescriptions }, idx) => {
    const isHidden = idx !== activeTab;
    const fieldName = `${namePrefix}[${idx}].${jobTitleFieldName}`;

    return <JobTitleCardList key={code} fieldName={fieldName} isHidden={isHidden} list={jobTitleDescriptions} />;
  });

  return <>{jobTitleContentsEl}</>;
};

export default JobTitleContents;
